var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "534.000000pt",
    height: "530.000000pt",
    viewBox: "0 0 534.000000 530.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,530.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2475 5246 c-167 -54 -287 -197 -316 -373 -32 -195 76 -389 267 -480 71 -34 82 -36 178 -37 90 -1 109 2 174 28 146 59 258 200 282 355 31 198 -75 398 -257 484 -62 29 -78 32 -178 34 -71 2 -124 -2 -150 -11z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411 5160 c-98 -21 -196 -104 -243 -206 -19 -41 -23 -66 -23 -149 0 -95 2 -103 34 -163 39 -72 88 -120 163 -159 48 -25 63 -28 153 -28 87 0 107 3 155 26 73 34 136 99 174 179 27 57 31 76 31 150 0 72 -4 94 -28 145 -58 123 -169 202 -299 210 -40 2 -93 0 -117 -5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3683 5151 c-59 -37 -83 -119 -55 -187 31 -75 144 -108 212 -62 86 57 93 166 16 237 -37 35 -127 41 -173 12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3105 5040 c-15 -46 4 -50 216 -50 190 0 199 1 209 21 24 44 4 49 -216 49 -195 0 -203 -1 -209 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3609 4828 c-14 -11 -120 -188 -361 -601 -38 -65 -68 -126 -66 -135 2 -10 14 -18 29 -20 24 -3 33 9 104 130 43 73 97 165 120 203 86 144 213 361 224 382 9 17 8 25 -5 37 -19 19 -26 20 -45 4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3863 4814 c-8 -21 -20 1 226 -414 177 -300 194 -325 219 -325 22 0 27 4 27 25 0 14 -69 140 -154 285 -85 143 -178 301 -206 350 -43 73 -58 91 -79 93 -18 2 -28 -2 -33 -14z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680 4480 c-237 -37 -434 -217 -495 -451 -22 -82 -22 -216 0 -298 56 -217 231 -385 452 -435 97 -22 183 -20 279 5 113 30 188 72 275 159 223 222 238 563 35 813 -120 146 -357 237 -546 207z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1860 4306 c-287 -80 -411 -421 -244 -672 147 -221 479 -256 666 -70 173 172 183 436 24 613 -53 58 -135 109 -208 129 -64 17 -177 17 -238 0z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2822 4308 c-19 -19 -16 -28 49 -137 55 -93 63 -102 87 -99 15 2 28 10 30 19 3 16 -84 173 -116 212 -18 20 -33 22 -50 5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3014 4016 c-66 -29 -103 -130 -70 -193 8 -17 29 -42 46 -57 26 -21 42 -26 87 -26 70 0 114 30 138 93 46 121 -80 235 -201 183z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4370 4012 c-98 -49 -107 -195 -15 -252 39 -24 113 -27 156 -5 71 37 94 154 42 216 -49 57 -119 74 -183 41z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 3899 c-9 -15 -8 -24 1 -35 10 -12 41 -14 168 -12 156 3 156 3 159 27 2 13 -2 28 -10 32 -7 5 -79 9 -160 9 -139 0 -148 -1 -158 -21z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3310 3906 c-6 -8 -9 -24 -5 -36 6 -20 12 -20 451 -20 402 0 445 2 451 16 3 9 2 24 -4 33 -9 14 -58 16 -445 19 -372 2 -437 0 -448 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2932 3682 c-32 -28 -253 -414 -250 -436 4 -30 42 -32 63 -4 37 52 245 411 245 424 0 7 -9 18 -19 24 -15 7 -24 6 -39 -8z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3197 3689 c-32 -18 -42 2 198 -404 65 -110 138 -234 162 -277 24 -42 51 -79 59 -82 18 -7 41 2 47 18 6 16 0 27 -335 595 -47 79 -91 147 -99 151 -8 5 -22 4 -32 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4279 3673 c-12 -14 -202 -334 -407 -684 -25 -42 11 -90 43 -58 33 33 426 714 423 733 -4 27 -40 32 -59 9z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4540 3664 c0 -14 55 -118 132 -247 72 -122 152 -258 178 -302 94 -160 105 -178 122 -188 18 -12 48 5 48 27 0 11 -400 697 -422 724 -6 6 -21 12 -34 12 -19 0 -24 -5 -24 -26z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2340 3174 c-83 -22 -138 -54 -205 -116 -191 -178 -191 -478 1 -657 68 -64 119 -92 209 -116 75 -19 118 -19 205 1 209 47 352 227 352 444 0 216 -133 386 -344 441 -84 22 -143 23 -218 3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291 3070 c-99 -36 -158 -88 -209 -184 -24 -46 -27 -61 -27 -156 0 -100 1 -108 34 -168 114 -210 386 -257 560 -96 83 77 115 151 115 264 0 72 -4 94 -28 148 -77 168 -275 253 -445 192z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 3021 c-127 -42 -210 -157 -210 -291 0 -136 84 -251 214 -291 74 -23 109 -24 180 -3 142 42 230 174 216 325 -17 193 -214 321 -400 260z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3716 2870 c-71 -21 -117 -105 -97 -177 31 -111 174 -145 252 -60 72 79 35 208 -67 236 -44 12 -48 12 -88 1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5076 2870 c-89 -28 -133 -137 -83 -210 36 -54 71 -74 127 -74 84 0 144 60 144 144 0 98 -95 169 -188 140z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3012 2758 c-7 -7 -12 -19 -12 -28 0 -37 18 -40 266 -40 207 0 245 2 258 16 9 8 16 19 16 24 0 5 -7 16 -16 24 -13 14 -51 16 -258 16 -175 0 -245 -3 -254 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4002 2758 c-7 -7 -12 -19 -12 -28 0 -39 10 -40 451 -40 375 0 429 2 443 16 20 19 20 29 0 48 -14 14 -68 16 -443 16 -319 0 -430 -3 -439 -12z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3613 2532 c-7 -5 -55 -80 -106 -168 -52 -87 -125 -211 -162 -274 -183 -308 -179 -302 -146 -319 33 -18 25 -30 281 409 37 63 92 156 122 205 68 112 71 121 52 140 -17 17 -24 18 -41 7z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3877 2528 c-26 -14 -21 -32 41 -136 32 -53 123 -207 202 -342 79 -135 150 -253 159 -263 20 -23 55 -18 59 9 2 12 -27 72 -71 145 -40 68 -113 192 -162 274 -201 343 -194 333 -228 313z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4958 2523 c-8 -10 -41 -63 -73 -118 -32 -55 -70 -120 -85 -145 -149 -244 -260 -443 -260 -465 0 -23 4 -26 28 -23 23 3 39 23 116 153 375 632 348 581 321 601 -24 18 -29 18 -47 -3z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2687 2234 c-14 -15 -6 -48 22 -93 16 -25 68 -113 116 -196 97 -167 117 -190 146 -175 10 6 19 16 19 23 0 12 -53 105 -189 332 -63 105 -91 132 -114 109z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625 2161 c-272 -68 -457 -303 -457 -581 0 -166 59 -310 176 -426 124 -123 258 -179 426 -177 456 3 741 489 524 894 -39 73 -164 197 -240 236 -76 41 -209 73 -294 72 -36 0 -96 -8 -135 -18z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1892 2009 c-127 -21 -243 -113 -307 -242 -33 -67 -39 -90 -43 -161 -7 -132 28 -231 117 -328 82 -90 193 -138 321 -138 295 0 506 283 420 561 -50 162 -185 283 -345 309 -68 11 -89 11 -163 -1z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2990 1694 c-45 -38 -63 -79 -57 -130 19 -172 255 -178 292 -7 9 42 -23 113 -63 141 -46 33 -130 31 -172 -4z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4353 1698 c-81 -57 -84 -176 -7 -237 59 -47 150 -36 203 24 26 30 31 44 31 86 0 95 -53 149 -145 149 -36 0 -59 -6 -82 -22z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520 1594 c-10 -11 -11 -20 -3 -32 8 -14 32 -17 149 -20 171 -3 186 0 182 36 l-3 27 -156 3 c-134 2 -158 0 -169 -14z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3305 1590 c-16 -50 -15 -50 453 -48 387 3 436 5 445 19 6 9 7 24 4 33 -6 14 -49 16 -451 16 -439 0 -445 0 -451 -20z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2870 1288 c-33 -56 -59 -109 -58 -117 5 -23 34 -37 51 -23 24 20 128 204 125 221 -2 9 -15 17 -30 19 -24 3 -32 -6 -88 -100z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3187 1383 c-18 -18 -17 -20 272 -508 81 -137 154 -251 163 -253 9 -2 23 4 32 13 13 13 14 21 5 38 -11 21 -124 214 -239 407 -31 52 -84 143 -119 203 -50 85 -68 107 -86 107 -12 0 -25 -3 -28 -7z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4071 1030 c-117 -199 -211 -369 -209 -378 2 -11 13 -17 32 -17 25 0 34 10 81 90 28 50 122 209 209 355 90 152 155 274 154 285 -2 13 -12 21 -28 23 -24 3 -41 -23 -239 -358z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2524 1100 c-74 -11 -184 -72 -244 -136 -96 -102 -144 -250 -122 -381 24 -146 127 -283 259 -346 65 -31 73 -32 193 -32 120 0 128 1 193 32 291 138 353 528 117 746 -111 103 -238 140 -396 117z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1388 997 c-100 -38 -166 -96 -216 -190 -24 -47 -27 -62 -27 -152 0 -87 3 -107 27 -157 34 -73 98 -137 174 -174 53 -26 69 -29 154 -28 86 0 100 3 155 31 76 40 136 102 172 178 24 51 28 73 28 145 0 74 -4 93 -31 150 -64 133 -168 202 -314 207 -55 2 -98 -2 -122 -10z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3705 571 c-38 -16 -74 -59 -85 -102 -10 -37 -9 -50 7 -88 27 -67 72 -94 145 -89 63 5 96 27 125 82 33 63 -6 164 -73 192 -37 15 -88 17 -119 5z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3110 455 c-6 -8 -10 -22 -8 -32 3 -17 20 -18 209 -21 171 -2 208 0 218 12 9 11 10 20 1 35 -10 20 -19 21 -209 21 -161 0 -201 -3 -211 -15z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.0ec6fb7c1496251b0818615b5a526bdf.svg";
export { ForwardRef as ReactComponent };